import React, { useEffect, useMemo, useState } from 'react'
import { getAuditoria } from 'src/services/preciosService'
import TablaPrecios from './TablaPrecios'

const isoLocal = (d) => {
  const off = d.getTimezoneOffset()
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10)
}
const _hoy = new Date()
const DEF_DESDE = isoLocal(new Date(_hoy.getFullYear(), _hoy.getMonth(), 1))
const DEF_HASTA = isoLocal(_hoy)

const AuditTab = ({ desde: desdeProp, hasta: hastaProp }) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  // periodo gobernado por selector global; fallback = mes actual (uso standalone)
  const desde = desdeProp ?? DEF_DESDE
  const hasta = hastaProp ?? DEF_HASTA

  useEffect(() => {
    setIsLoading(true)
    getAuditoria(desde, hasta).then((res) => {
      if (res && res.success) setData(res.data)
      setIsLoading(false)
    })
  }, [desde, hasta])

  const columns = useMemo(
    () => [
      { accessorKey: 'fecha', header: 'Fecha/hora' },
      { accessorKey: 'usuario', header: 'Usuario' },
      { accessorKey: 'accion', header: 'Acción' },
      { accessorKey: 'detalle', header: 'Detalle' },
    ],
    [],
  )

  return (
    <div>
      <h3 className="precios-section-title" style={{ marginTop: 0, marginBottom: 2 }}>Auditoría / trazabilidad</h3>
      <p style={{ fontSize: 12.5, color: '#6b7684', marginTop: 0 }}>
        Registro de quién cambió qué y cuándo en el Centralizador — reemplaza la cadena de correos, WhatsApp y Excel.
        <br />
        <span style={{ fontSize: 11, color: '#9aa4ad' }}>Periodo: {desde} → {hasta} · usa el selector de arriba.</span>
      </p>
      <TablaPrecios columns={columns} data={data} isLoading={isLoading} pageSize={25} />
    </div>
  )
}

export default AuditTab
